import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledModal,
  StyledModalContent,
  StyledModalHeader,
  StyledIconClose,
  StyledHeading
} from './style';
import IconRemove from '../../../../assets/images/svg/remove.svg';

const Modal = props => (
  <StyledModal>
    <StyledModalContent className={props.className} height={props.height}>
      <StyledModalHeader>
        <StyledIconClose
          hover
          color="main"
          onClick={props.onClose}
          size="xs"
          svg={IconRemove}
        />
        <StyledHeading headingType={2}>{props.title}</StyledHeading>
      </StyledModalHeader>
      {props.children}
    </StyledModalContent>
  </StyledModal>
);

Modal.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  onClose: PropTypes.func,
  title: PropTypes.string,
  height: PropTypes.string
};

export default Modal;
